/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactForm
 */
export interface ContactForm {
    /**
     * 
     * @type {string}
     * @memberof ContactForm
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactForm
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactForm
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactForm
     */
    recaptchaToken?: string;
}

/**
 * Check if a given object implements the ContactForm interface.
 */
export function instanceOfContactForm(value: object): value is ContactForm {
    return true;
}

export function ContactFormFromJSON(json: any): ContactForm {
    return ContactFormFromJSONTyped(json, false);
}

export function ContactFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactForm {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'question': json['question'] == null ? undefined : json['question'],
        'recaptchaToken': json['recaptchaToken'] == null ? undefined : json['recaptchaToken'],
    };
}

export function ContactFormToJSON(json: any): ContactForm {
    return ContactFormToJSONTyped(json, false);
}

export function ContactFormToJSONTyped(value?: ContactForm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'question': value['question'],
        'recaptchaToken': value['recaptchaToken'],
    };
}

